export default __webpack_public_path__ + "static/media/OGCreative.a520a316.webp";